module.exports = __webpack_public_path__ + "static/media/dem_pre_wea_pla.59a3efac.png";